import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
// @mui
import {Typography, Grid, Stack, Button, Card } from '@mui/material';
import PlanCard from './PlansCard';
import { SUPPORT_WHATSAPP_URL } from '../../../utils/constants';

// ----------------------------------------------------------------------

PlansList.propTypes = {
    plans: PropTypes.array.isRequired,
    SelectPlan: PropTypes.func.isRequired,
};

const CustomPlanCard = (props) => {

  return (
    <Card>
      <Stack spacing={2} sx={{ p: 3 }}>
        <Typography variant="subtitle1" noWrap>
        Não achou o que procurava?
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Solicite um plano personalizado.
          </Typography>
        </Stack>
          <Button variant="contained" size="large" onClick={_ => props.HandleCustomPlan()}>Falar com Comercial</Button>
      </Stack>
    </Card>
  );
}


export default function PlansList({ plans, SelectPlan, ...other }) {

    const navigate = useNavigate();

    const HandleCustomPlan = () => {
        const whatsappURL = `${SUPPORT_WHATSAPP_URL.replace('suporte', 'solicitar um plano personalizado')}`;
        window.open(whatsappURL, '_blank');  
    };

  return (
    <Grid container spacing={2} {...other}>
      {plans.map((plan) => (
        <Grid key={plan.id} item  xs={12} sm={6} md={4}>
          <PlanCard plan={plan} SelectPlan={SelectPlan} />
        </Grid>
      ))}
        <Grid item  xs={12} sm={6} md={4}>
          <CustomPlanCard HandleCustomPlan={HandleCustomPlan}/>
        </Grid>
    </Grid>
  );
}